// Funktion zur Formatierung von Preisen (Cents) – konsistent mit dem Liquid `money`-Filter
function formatPrice(cents) {
    if (cents === '' || cents == null || isNaN(cents)) return '';

    // Money-Format aus Liquid; wird in snippets/theme-setup.liquid als
    // window.theme.moneyFormat = "{{ shop.money_format }}" gesetzt.
    const moneyFormat = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';

    // Shopify.formatMoney (aus option_selection.js) nutzt exakt dieses money_format,
    // damit JS-Preise identisch zu serverseitig gerenderten Preisen formatiert werden.
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
    }

    // Fallback, falls Shopify.formatMoney (noch) nicht verfügbar ist
    const euros = cents / 100;
    return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    }).format(euros);
}

document.addEventListener('DOMContentLoaded', function() {
    // Hilfsfunktion: UI für "gerettete Plastikflaschen" aktualisieren
    function updateSavedPlasticUI(text) {
        const container = document.querySelector('[data-saved-plastic]');
        const textNode = document.querySelector('[data-saved-plastic-text]');
        if (!container || !textNode) return; // Block existiert evtl. nicht auf allen Produkten

        const value = (text || '').toString().trim();
        if (value) {
            textNode.textContent = value;
            container.style.display = '';
        } else {
            // Falls neue Variante keinen Wert hat, Block ausblenden
            container.style.display = 'none';
        }
    }

    // Hilfsfunktion: ausgewählte Varianten-Option aus dem Selector holen
    function getSelectedVariantOption() {
        const variantSelector = document.querySelector('[data-variant-select]');
        if (!variantSelector) return null;
        return variantSelector.options[variantSelector.selectedIndex] || null;
    }

    // Funktion zum Anpassen der Höhe der variant-image-tile__label Elemente
    function adjustVariantTileLabelsHeight() {
        // Alle label-Elemente auswählen
        const labelElements = document.querySelectorAll('.variant-image-tile__label');
        
        if (labelElements.length === 0) return;
        
        // Höhe zurücksetzen, um korrekte Messung zu ermöglichen
        labelElements.forEach(label => {
            label.style.height = 'auto';
        });
        
        // Maximale Höhe ermitteln
        let maxHeight = 0;
        labelElements.forEach(label => {
            const height = label.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        
        // Höhe für alle Elemente setzen
        if (maxHeight > 0) {
            labelElements.forEach(label => {
                label.style.height = maxHeight + 'px';
            });
        }
    }
    
    // Funktion beim Laden der Seite ausführen
    adjustVariantTileLabelsHeight();
    
    // Funktion auch beim Resize des Fensters ausführen
    window.addEventListener('resize', adjustVariantTileLabelsHeight);
    
    // Funktion auch ausführen, wenn Bilder geladen sind (falls Bilder die Höhe beeinflussen)
    window.addEventListener('load', adjustVariantTileLabelsHeight);
    
    // Funktion zum Aktualisieren der Varianten-ID im Formular und ATC-Button direkt aus der URL
    function updateVariantIdFromURL() {
        // Hole die Varianten-ID aus der URL
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        
        if (variantId) {
            // Aktualisiere das Formular
            const productForm = document.querySelector('.custom-product-form');
            if (productForm) {
                productForm.setAttribute('data-current-product-id', variantId);
            }
            
            // Aktualisiere den ATC-Button
            const atcButton = document.querySelector('[data-variant-atc-id]');
            if (atcButton) {
                atcButton.setAttribute('data-variant-atc-id', variantId);
            }
            
            // Aktualisiere auch das versteckte Select-Element
            const variantSelector = document.getElementById('variant-selector');
            if (variantSelector) {
                variantSelector.value = variantId;
            }
            
            return true;
        }
        return false;
    }
    
    // Wenn keine Varianten-ID in der URL ist, verwende die vorausgewählte Variante
    function updateVariantIdFromSelector() {
        const variantSelector = document.getElementById('variant-selector');
        if (variantSelector && variantSelector.value) {
            const selectedVariantId = variantSelector.value;
            
            // Aktualisiere das Formular
            const productForm = document.querySelector('.custom-product-form');
            if (productForm) {
                productForm.setAttribute('data-current-product-id', selectedVariantId);
            }
            
            // Aktualisiere den ATC-Button
            const atcButton = document.querySelector('[data-variant-atc-id]');
            if (atcButton) {
                atcButton.setAttribute('data-variant-atc-id', selectedVariantId);
            }
            
            // Varianten-ID wurde aktualisiert
        }
    }
    
    // Initialisiere die Varianten-ID beim Laden der Seite
    // Versuche zuerst aus der URL, dann aus dem Selektor
    if (!updateVariantIdFromURL()) {
        updateVariantIdFromSelector();
    }
    
    // Variant Images Grid Functionality
    const variantImageTiles = document.querySelectorAll('.variant-image-tile');
    const optionGroups = document.querySelectorAll('[data-ds-option-group]');

    function findTileForValue(grid, value) {
        if (!grid) return null;
        try {
            if (window.CSS && typeof window.CSS.escape === 'function') {
                return grid.querySelector(`.variant-image-tile[title="${window.CSS.escape(value)}"]`);
            }
        } catch (e) {
            // ignore
        }

        const tiles = grid.querySelectorAll('.variant-image-tile');
        for (const tile of tiles) {
            if (tile.getAttribute('title') === value) return tile;
        }
        return null;
    }

    function getDisplayTitleForOptionValue(optionPosition, value) {
        const grid = document.querySelector(`[data-product-option="Option${optionPosition}"]`);
        const tile = findTileForValue(grid, value);
        return (tile && tile.getAttribute('data-display-title')) || value;
    }

    function syncOptionGroupSelected(group) {
        const optionPosition = group.getAttribute('data-option-position');
        const selectElement = document.getElementById('option' + optionPosition);
        const selectedEl = group.querySelector('[data-ds-option-group-selected]');
        if (!selectElement || !selectedEl) return;
        selectedEl.textContent = getDisplayTitleForOptionValue(optionPosition, selectElement.value);
    }

    function syncAllOptionGroupSelected() {
        optionGroups.forEach(group => syncOptionGroupSelected(group));
    }

    function getOptionGroupBody(group) {
        return group.querySelector('[data-ds-option-group-body]') || group.querySelector('.ds-product__option-group__body');
    }

    function expandOptionGroup(group) {
        const body = getOptionGroupBody(group);
        group.classList.remove('is-collapsed');
        if (!body) return;

        body.style.overflow = 'hidden';

        // Start from 0 -> scrollHeight
        body.style.height = '0px';
        // Force reflow
        body.offsetHeight;
        body.style.opacity = '1';
        body.style.height = body.scrollHeight + 'px';

        body.addEventListener('transitionend', (e) => {
            if (e.propertyName !== 'height') return;
            body.style.height = '';
            body.style.overflow = '';
        }, { once: true });
    }

    function collapseOptionGroup(group) {
        const body = getOptionGroupBody(group);
        if (!body) {
            group.classList.add('is-collapsed');
            return;
        }

        body.style.overflow = 'hidden';

        // Set explicit height so we can animate to 0
        body.style.height = body.scrollHeight + 'px';
        body.style.opacity = '1';
        // Force reflow
        body.offsetHeight;

        group.classList.add('is-collapsed');
        body.style.height = '0px';

        body.addEventListener('transitionend', (e) => {
            if (e.propertyName !== 'height') return;
            body.style.height = '';
            body.style.overflow = '';
        }, { once: true });
    }

    if (optionGroups.length) {
        syncAllOptionGroupSelected();
        optionGroups.forEach(group => {
            const header = group.querySelector('[data-ds-option-group-header]');
            if (!header) return;
            header.addEventListener('click', function () {
                if (group.classList.contains('is-collapsed')) {
                    expandOptionGroup(group);
                } else {
                    collapseOptionGroup(group);
                }
            });
        });
    }

    function updateBundleSummary() {
        const summary = document.querySelector('[data-bundle-summary]');
        if (!summary) return;

        const items = summary.querySelectorAll('[data-bundle-summary-item]');
        items.forEach(item => {
            const idx = parseInt(item.getAttribute('data-index'), 10);
            if (Number.isNaN(idx)) return;

            const selectElement = document.getElementById('option' + (idx + 1));
            const valueEl = item.querySelector('.ds-bundle-summary__value');
            if (!selectElement || !valueEl) return;

            valueEl.textContent = getDisplayTitleForOptionValue(idx + 1, selectElement.value);
        });
    }

    updateBundleSummary();

    const onVariantChange = () => {
        setTimeout(() => {
            updateBundleSummary();
            syncAllOptionGroupSelected();
        }, 0);
    };

    document.addEventListener('product:variant-change', onVariantChange);
    window.addEventListener('product:variant-change', onVariantChange);
    
    variantImageTiles.forEach(tile => {
        tile.addEventListener('click', function() {
            if (this.hasAttribute('data-fake-variant-tile')) return;
            if (this.tagName !== 'BUTTON') return;

            const productOptionEl = this.closest('[data-product-option]');
            if (!productOptionEl) return;

            // Get the value and option position from the button
            const value = this.getAttribute('title');
            const optionPosition = productOptionEl.getAttribute('data-product-option').replace('Option', '');
            
            // Find the corresponding select element
            const selectElement = document.getElementById('option' + optionPosition);
            
            if (selectElement) {
                // Set the value in the select element
                selectElement.value = value;
                
                // Prüfe, ob der Cart-Drawer geöffnet ist
                const cartDrawerOpen = document.querySelector('.drawer--visible') !== null;
                
                // Wenn der Cart-Drawer geöffnet ist, warte einen Moment, bis die Animation abgeschlossen ist
                if (cartDrawerOpen) {
                    // Warte 50ms, um sicherzustellen, dass der DOM stabil ist
                    setTimeout(() => {
                        // Trigger the change event to update the variant
                        try {
                            const event = new Event('change', { bubbles: true });
                            selectElement.dispatchEvent(event);
                        } catch (error) {
                            console.error('Fehler beim Auslösen des Change-Events:', error);
                        }
                    }, 50);
                } else {
                    // Trigger the change event to update the variant
                    try {
                        const event = new Event('change', { bubbles: true });
                        selectElement.dispatchEvent(event);
                    } catch (error) {
                        console.error('Fehler beim Auslösen des Change-Events:', error);
                    }
                }
                
                // Update visual selection
                const allTiles = this.closest('.variant-images-grid').querySelectorAll('.variant-image-tile');
                allTiles.forEach(t => t.classList.remove('selected'));
                this.classList.add('selected');

                updateBundleSummary();

                const optionGroup = this.closest('[data-ds-option-group]');
                if (optionGroup) {
                    syncOptionGroupSelected(optionGroup);
                    if (optionGroup._dsCollapseTimeoutId) {
                        clearTimeout(optionGroup._dsCollapseTimeoutId);
                    }

                    optionGroup._dsCollapseTimeoutId = window.setTimeout(() => {
                        collapseOptionGroup(optionGroup);
                        optionGroup._dsCollapseTimeoutId = null;
                    }, 500);
                }
                
                // Hole die Varianten-Daten aus dem Variantenselektorelement
                if (selectElement) {
                    const variantSelector = document.querySelector('[data-variant-select]');
                    if (variantSelector) {
                        // Finde die ausgewählte Option basierend auf dem Wert
                        let selectedVariantOption = Array.from(variantSelector.options).find(option => {
                            return option.value === value || option.textContent.trim().includes(value);
                        });
                        
                        // Fallback: Nutze den ausgewählten Index
                        if (!selectedVariantOption && selectElement.selectedIndex >= 0) {
                            selectedVariantOption = variantSelector.options[variantSelector.selectedIndex];
                        }
                        
                        if (selectedVariantOption) {
                            // Hole die Preis-Daten aus der ausgewählten Variante
                            const variantPrice = selectedVariantOption.getAttribute('data-variant-price');
                            const variantComparePrice = selectedVariantOption.getAttribute('data-variant-compare-price');
                            const variantSavedPlastic = selectedVariantOption.getAttribute('data-variant-saved-plastic');
                            
                            // Formatiere die Preise
                            const formattedPrice = formatPrice(variantPrice);
                            const formattedComparePrice = formatPrice(variantComparePrice);
                            
                            // Preis aktualisieren
                            const priceNode = document.querySelector('.product__price .money');
                            if (priceNode && variantPrice) {
                                priceNode.innerHTML = formattedPrice;
                                
                                // Wenn ein Compare-Price vorhanden ist, färbe den Preis rot
                                if (variantComparePrice && variantComparePrice !== '') {
                                    // Finde das übergeordnete Element mit der Klasse product__price
                                    const priceContainer = priceNode.closest('.product__price');
                                    if (priceContainer) {
                                        priceContainer.classList.add('ds-colored-price');
                                        priceContainer.style.color = '#f45b69'; // Rote Farbe
                                    }
                                } else {
                                    // Kein Compare-Price, setze die Farbe zurück
                                    const priceContainer = priceNode.closest('.product__price');
                                    if (priceContainer) {
                                        priceContainer.classList.remove('ds-colored-price');
                                        priceContainer.style.color = ''; // Standardfarbe
                                    }
                                }
                            }
                            
                            // Compare-Price aktualisieren
                            const priceContainer = document.querySelector('.product__title-price-container .product__price.product__block');
                            // Der <s>-Tag gehört – wie im Liquid – in dieselbe .ds--price-group wie der Preis
                            const priceGroup = priceContainer && priceContainer.querySelector('.ds--price-group');
                            const priceElement = priceContainer && priceContainer.querySelector('[data-price]');

                            if (priceGroup && priceElement) {
                                // Compare-Price-Element innerhalb der Price-Group suchen
                                let compareNode = priceGroup.querySelector('[data-compare-price]');

                                if (variantComparePrice && variantComparePrice !== '') {
                                    // Es gibt einen Compare-Price
                                    if (!compareNode) {
                                        // Element existiert nicht: neu erstellen und vor dem
                                        // Preiselement innerhalb der .ds--price-group einfügen,
                                        // damit das Flex-Layout nicht bricht.
                                        const newCompareNode = document.createElement('s');
                                        newCompareNode.setAttribute('data-compare-price', '');
                                        newCompareNode.innerHTML = `<span class="money">${formattedComparePrice}</span>`;
                                        priceElement.before(newCompareNode);
                                        compareNode = newCompareNode;
                                    } else {
                                        // Element existiert, aktualisiere den Inhalt
                                        compareNode.innerHTML = `${formattedComparePrice}`;
                                        compareNode.style.display = '';
                                    }
                                } else if (compareNode) {
                                    // Kein Compare-Price, ausblenden
                                    compareNode.style.display = 'none';
                                }
                            }
                            
                            // Aktualisiere variant-compare-at-price Elemente (außer in variant-image-tile)
                            document.querySelectorAll('.variant-compare-at-price').forEach(node => {
                                // Überspringe Elemente in variant-image-tile
                                if (node.closest('.variant-image-tile')) return;
                                
                                if (variantComparePrice && variantComparePrice !== '') {
                                    node.textContent = formattedComparePrice;
                                    node.style.display = '';
                                    
                                    // Farbe des übergeordneten Elements anpassen
                                    const parentPrice = node.closest('.variant-price');
                                    if (parentPrice) parentPrice.style.color = '#f45b69';
                                } else {
                                    node.style.display = 'none';
                                    
                                    // Farbe zurücksetzen
                                    const parentPrice = node.closest('.variant-price');
                                    if (parentPrice) parentPrice.style.color = '';
                                }
                            });

                            // "Gerettete Plastikflaschen" UI aktualisieren
                            updateSavedPlasticUI(variantSavedPlastic);
                        }
                    }
                }
            }
        });
    });

    // Mobile Upsell Slider (for PDP upsell cards)
    (function initUpsellMobileSlider() {
        const MOBILE_QUERY = window.matchMedia('(max-width: 60em)'); // align with CSS breakpoints

        function setupContainer(container) {
            if (!container || container.dataset.upsellSliderInitialized === 'true') return;

            const slides = Array.from(container.querySelectorAll('[data-upsell-slide]'));
            if (slides.length === 0) return;

            // Find the closest dots container within the same upsell block
            let dotsContainer = container.parentElement && container.parentElement.querySelector('[data-upsell-dots]');
            if (!dotsContainer) {
                dotsContainer = document.createElement('div');
                dotsContainer.className = 'ds-upsell-dots';
                dotsContainer.setAttribute('data-upsell-dots', '');
                container.after(dotsContainer);
            }

            // Create dots
            dotsContainer.innerHTML = '';
            const dots = slides.map((slide, index) => {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'ds-upsell-dot';
                dot.setAttribute('aria-label', `Slide ${index + 1}`);
                dot.addEventListener('click', () => {
                    // Scroll nur innerhalb des Containers, nicht die ganze Seite
                    const left = slide.offsetLeft;
                    if (typeof container.scrollTo === 'function') {
                        container.scrollTo({ left, behavior: 'smooth' });
                    } else {
                        container.scrollLeft = left; // Fallback
                    }
                });
                dotsContainer.appendChild(dot);
                return dot;
            });

            // Mark first as active initially
            function setActive(index) {
                dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
            }
            setActive(0);

            // Observe slide visibility to update active dot
            const obs = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const idx = slides.indexOf(entry.target);
                        if (idx >= 0) setActive(idx);
                    }
                });
            }, { root: container, threshold: 0.6 });
            slides.forEach(slide => obs.observe(slide));

            // Enable momentum scroll on mobile only; on desktop we do nothing
            container.style.scrollSnapType = 'x mandatory';
            slides.forEach(s => { s.style.scrollSnapAlign = 'start'; });
            container.dataset.upsellSliderInitialized = 'true';

            // Clean-up function on teardown
            function teardown() {
                try { obs.disconnect(); } catch (e) {}
                dotsContainer.innerHTML = '';
                container.style.scrollSnapType = '';
                slides.forEach(s => { s.style.scrollSnapAlign = ''; });
                delete container.dataset.upsellSliderInitialized;
            }

            return teardown;
        }

        let teardowns = [];

        function mountIfMobile() {
            // Teardown previous
            teardowns.forEach(fn => { try { fn && fn(); } catch (e) {} });
            teardowns = [];

            if (!MOBILE_QUERY.matches) return; // only on mobile

            const containers = document.querySelectorAll('[data-upsell-slider]');
            containers.forEach(container => {
                const td = setupContainer(container);
                if (typeof td === 'function') teardowns.push(td);
            });
        }

        mountIfMobile();
        MOBILE_QUERY.addEventListener('change', mountIfMobile);
        window.addEventListener('cart-update', () => {
            // Re-mount after cart updates in case DOM changes
            setTimeout(mountIfMobile, 150);
        });
        // Expose re-init globally so PDP can call after injecting recommendations
        window.initUpsellMobileSlider = mountIfMobile;
        // Re-mount when PDP dispatches custom event after DOM updates
        window.addEventListener('upsell:updated', () => {
            setTimeout(mountIfMobile, 0);
        });
    })();
    
    // Dropdown Variant Buttons Functionality
    const swatchButtons = document.querySelectorAll('[data-swatch-button="true"]');
    
    swatchButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Get the value and option position from the button
            const value = this.getAttribute('data-label');
            const optionPosition = this.closest('[data-product-option]').getAttribute('data-product-option').replace('Option', '');
            
            // Find the corresponding select element
            const selectElement = document.getElementById('option' + optionPosition);
            
            if (selectElement) {
                // Set the value in the select element
                selectElement.value = value;
                
                // Trigger the change event to update the variant
                const changeEvent = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(changeEvent);
                
                // Update visual selection
                const allButtons = this.closest('.product__color-swatches').querySelectorAll('[data-swatch-button="true"]');
                allButtons.forEach(b => b.classList.remove('selected'));
                this.classList.add('selected');
                
                // Update the displayed value
                const swatchValueElement = this.closest('.option-dropdown__title').querySelector('[data-swatch-selected]');
                if (swatchValueElement) {
                    swatchValueElement.textContent = value;
                }

                // Auch die Saved-Plastic-Anzeige aktualisieren
                const selectedOption = getSelectedVariantOption();
                if (selectedOption) {
                    const variantSavedPlastic = selectedOption.getAttribute('data-variant-saved-plastic');
                    updateSavedPlasticUI(variantSavedPlastic);
                }
            }
        });
    });
    
    // Event-Listener für Änderungen an den Select-Elementen
    // Dies wird ausgelöst, wenn eine Variante durch Klick auf einen Button geändert wird
    const optionSelects = document.querySelectorAll('select[id^="option"]');
    optionSelects.forEach(select => {
        select.addEventListener('change', function() {
            // Warte kurz, bis die Variante aktualisiert wurde
            setTimeout(() => {
                updateVariantIdFromURL() || updateVariantIdFromSelector();
                const selectedOption = getSelectedVariantOption();
                if (selectedOption) {
                    const variantSavedPlastic = selectedOption.getAttribute('data-variant-saved-plastic');
                    updateSavedPlasticUI(variantSavedPlastic);
                }
            }, 100);
        });
    });
    
    // Product Listing Variant Functionality
    const productElements = document.querySelectorAll('[data-product-id]');
    
    productElements.forEach(productElement => {
        const variantItems = productElement.querySelectorAll('.product-item-options__item--swatch');
        const variantImages = productElement.querySelectorAll('.ds-product-item__image--two');

        function resetImages() {
            variantImages.forEach(img => {
                img.style.opacity = '0';
                img.classList.remove('active');
            });
            variantItems.forEach(item => {
                item.classList.remove('ds-active');
            });
        }

        resetImages();

        // Set first variant item as active
        if (variantItems.length > 0) {
            variantItems[0].classList.add('ds-active');
        }

        variantItems.forEach(item => {
            const variantId = item.dataset.variant;
            if (!variantId) return;

            item.addEventListener('click', (event) => {
                event.preventDefault();
                resetImages();
                
                // Update product ID with variant ID
                productElement.dataset.productId = variantId;
                
                // Update image
                const matchingImage = productElement.querySelector(`.ds-product-item__image--two img[data-variant="${variantId}"]`);
                const matchingWrapper = matchingImage ? matchingImage.closest('.ds-product-item__image--two') : null;
                
                // Hide default product image
                const defaultImage = productElement.querySelector('.product-item__image--one img');
                if (defaultImage) {
                    defaultImage.style.opacity = '0';
                }

                if (matchingWrapper) {
                    matchingWrapper.style.opacity = '1';
                    matchingWrapper.classList.add('active');
                    item.classList.add('ds-active');
                }

                // Update all product links to include the variant ID
                const productLinks = productElement.querySelectorAll('a[href*="/products/"]');
                productLinks.forEach(link => {
                    const url = new URL(link.href);
                    url.searchParams.set('variant', variantId);
                    link.href = url.toString();
                });

                // Update the add to cart form
                const form = productElement.querySelector('.product-form');
                if (form) {
                    // Update hidden input value
                    const variantInput = form.querySelector('input[name="id"]');
                    if (variantInput) variantInput.value = variantId;

                    // Update form data attribute
                    form.dataset.currentProductId = variantId;

                    // Update ATC button data attribute
                    const atcButton = form.querySelector('.ds-custom-atc-button');
                    if (atcButton) atcButton.dataset.variantAtcId = variantId;
                }

                // Update prices
                const variantPrices = productElement.querySelector('[data-variant-prices]');
                if (variantPrices) {
                    const variantPrice = variantPrices.querySelector(`[data-variant-id="${variantId}"]`);
                    if (variantPrice) {
                        const price = parseInt(variantPrice.dataset.price, 10) / 100; // Convert cents to euros
                        const comparePrice = variantPrice.dataset.comparePrice ? parseInt(variantPrice.dataset.comparePrice, 10) / 100 : 0;
                        const priceElement = variantPrices.querySelector('[data-price-element]');
                        const comparePriceElement = variantPrices.querySelector('[data-compare-price-element]');

                        if (priceElement) {
                            // Format price with currency
                            const formattedPrice = new Intl.NumberFormat('de-DE', {
                                style: 'currency',
                                currency: 'EUR',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }).format(price).replace(/\s/g, '');

                            priceElement.textContent = formattedPrice;
                            
                            // Update price element class based on whether it's on sale
                            priceElement.className = comparePrice > price ? 'sale ds-colored-price' : 'product-item__price';
                        }

                        if (comparePriceElement) {
                            if (comparePrice > price) {
                                const formattedComparePrice = new Intl.NumberFormat('de-DE', {
                                    style: 'currency',
                                    currency: 'EUR',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }).format(comparePrice).replace(/\s/g, '');
                                
                                comparePriceElement.textContent = formattedComparePrice;
                                comparePriceElement.style.display = '';
                            } else {
                                comparePriceElement.style.display = 'none';
                            }
                        }
                    }
                }
            });
        });
    });


    
});